import { Space } from "antd";
import React from "react";
import { SectionCardWrapper } from "../../../Components/UI/SectionCardWrapper";
import { SectionCardHeading } from "./style";
import "./style.css";
import { withScroll } from "../../../HOC/withScroll";
import { useSelector } from "react-redux";
import { Wrapper } from "../../../Constant";

const ThankyouPage = () => {
  const { transactionId, name, isUpiAsba } = useSelector((state) => state.policyDetails);

  return (
    <>
      <div className="container">
        <Wrapper>
          <SectionCardWrapper>
            <div className="container">
              <Space direction="vertical">
                <SectionCardHeading>Hi {name}!</SectionCardHeading>
                <label className={"cls_mghuntl9_8135f1"}>
                  {`You have successfully Paid the Amount`}
                  <br />
                  <br />
                  {!isUpiAsba && `Your transactionId is -: ${transactionId}`}
                </label>
              </Space>
            </div>
          </SectionCardWrapper>
        </Wrapper>
      </div>
    </>
  );
};

export default withScroll(ThankyouPage);
